import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterValues } from '../../../redux/reducers';
import 'react-datepicker/dist/react-datepicker.css';
import "./style.scss";
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { FilterContext } from '../../../providers/filterData-provider';

const Filter = () => {

    const [filterOptions, setFilterOptions] = useState({});
    const [selectedFilterValues, setSelectedFilterValues] = useState({});

    // const [selLendFilterValues, setSelLendFilterValues] = useState({});

    const { selectedLendFilterValues, setSelectedLendFilterValues } = useContext(FilterContext);

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();
    const location = useLocation();
    // const filterDashboardData = useSelector(state => state?.filter?.data);
    let filterDashboardData = "";

    console.log("location?.pathname:::", location)

    if (location?.pathname === "/dashboard/collect") {
        console.log("------------------collect")
        filterDashboardData = useSelector(state => state?.filter?.data);
    } else if (location?.pathname === "/dashboard/lend") {
        filterDashboardData = useSelector(state => state?.lendFilter?.data);
    }

console.log("filterDashboardData:::::", filterDashboardData)

    useEffect(() => {
        const fetchFilterOptions = async () => {
            const options = {};
            await Promise.all(
                filterDashboardData && filterDashboardData.map(async (filterItem) => {
                    if (filterItem.FILTER_ID) {
                        try {
                            const response = await axios.get(`${baseUrl}/api/filter/${filterItem.FILTER_ID}`);
                            options[filterItem.FILTER_ID] = response.data.data.map(item => item[filterItem.BASE_COLUMN]);
                        } catch (error) {
                            console.error(`Error fetching options for ${filterItem.FILTER_ID}:`, error);
                        }
                    }
                })
            );
            setFilterOptions(options);
            // dispatch(selectedFilterValues);
            // console.log(filterOptions);
        };

        fetchFilterOptions();
    }, [filterDashboardData]);

    const handleFilterChange = (event, filterId) => {
        const value = event.target.value;
        setSelectedFilterValues(prevValues => ({
            ...prevValues,
            [filterId]: value
        }));
        setSelectedFilterValues(prevValues => (
            {
                ...prevValues,
                [filterId]: value
            }
        ));
    };

    console.log("==================>filter selectedLendFilterValues", selectedLendFilterValues);
    const onClickHandler = () => {
        dispatch(setFilterValues(selectedFilterValues));
        setSelectedLendFilterValues(() => (
            { ...selectedFilterValues }
        ));
        // console.log("==================>filter selected values", selectedFilterValues);
    };

    const removeSelectedFilterValue = (id) => {
        const updatedSelectedFilterValues = { ...selectedFilterValues };
        delete updatedSelectedFilterValues[id];
        setSelectedFilterValues(updatedSelectedFilterValues);
    }

    // console.log("selLendFilterValues:::::>", selLendFilterValues);

    return (
        <div className='filter-container'>
            <div className='filter-container__header'>
                <p>Filters</p>
                <div className='filter-container__header__icons'>
                    <p className='refresh'><svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                        <path d="M1.15386 8.08285C1.15411 6.80299 1.54077 5.55307 2.26316 4.49693C2.98554 3.44079 4.00994 2.62772 5.20208 2.16428C6.39421 1.70085 7.69845 1.60869 8.94383 1.89987C10.1892 2.19105 11.3176 2.852 12.1811 3.79607L9.62538 4.6488C9.55341 4.67276 9.48685 4.71067 9.42952 4.76037C9.37218 4.81007 9.32519 4.87058 9.29123 4.93845C9.25727 5.00633 9.23699 5.08023 9.23157 5.15594C9.22614 5.23165 9.23567 5.30769 9.25961 5.37972C9.28355 5.45175 9.32144 5.51835 9.3711 5.57573C9.42076 5.6331 9.48123 5.68013 9.54905 5.71412C9.61687 5.74811 9.69072 5.7684 9.76638 5.77382C9.84204 5.77925 9.91802 5.76972 9.99 5.74576L13.4515 4.59107C13.5667 4.55267 13.6669 4.47887 13.7378 4.38019C13.8086 4.2815 13.8465 4.16296 13.8461 4.04144V0.577375C13.8461 0.424253 13.7854 0.277404 13.6772 0.169131C13.569 0.0608576 13.4222 3.05176e-05 13.2692 3.05176e-05C13.1162 3.05176e-05 12.9695 0.0608576 12.8613 0.169131C12.7531 0.277404 12.6923 0.424253 12.6923 0.577375V2.68641C11.6351 1.66219 10.2998 0.972471 8.85315 0.703451C7.4065 0.434431 5.91271 0.598041 4.55845 1.17384C3.20419 1.74963 2.04954 2.71207 1.2388 3.94088C0.428056 5.16969 -0.00282191 6.61036 1.39083e-05 8.08285C1.39083e-05 8.23597 0.0607966 8.38282 0.16899 8.49109C0.277184 8.59936 0.423927 8.66019 0.576936 8.66019C0.729945 8.66019 0.876688 8.59936 0.984881 8.49109C1.09308 8.38282 1.15386 8.23597 1.15386 8.08285ZM14.4231 7.5055C14.2701 7.5055 14.1233 7.56633 14.0151 7.6746C13.9069 7.78288 13.8461 7.92973 13.8461 8.08285C13.8459 9.3627 13.4592 10.6126 12.7368 11.6688C12.0145 12.7249 10.9901 13.538 9.79793 14.0014C8.60579 14.4648 7.30155 14.557 6.05617 14.2658C4.81079 13.9746 3.68238 13.3137 2.81886 12.3696L5.37462 11.5169C5.44659 11.4929 5.51315 11.455 5.57048 11.4053C5.62782 11.3556 5.67481 11.2951 5.70877 11.2272C5.74274 11.1594 5.76301 11.0855 5.76843 11.0098C5.77386 10.934 5.76433 10.858 5.74039 10.786C5.71645 10.7139 5.67856 10.6473 5.6289 10.59C5.57924 10.5326 5.51877 10.4856 5.45095 10.4516C5.38313 10.4176 5.30928 10.3973 5.23362 10.3919C5.15796 10.3864 5.08198 10.396 5.01 10.4199L1.54847 11.5746C1.43327 11.613 1.3331 11.6868 1.26225 11.7855C1.1914 11.8842 1.15346 12.0027 1.15386 12.1243V15.5883C1.15386 15.7414 1.21464 15.8883 1.32283 15.9966C1.43103 16.1048 1.57777 16.1657 1.73078 16.1657C1.88379 16.1657 2.03053 16.1048 2.13873 15.9966C2.24692 15.8883 2.3077 15.7414 2.3077 15.5883V13.4793C3.36485 14.5035 4.70019 15.1932 6.14685 15.4622C7.5935 15.7313 9.08729 15.5677 10.4415 14.9919C11.7958 14.4161 12.9505 13.4536 13.7612 12.2248C14.5719 10.996 15.0028 9.55534 15 8.08285C15 7.92973 14.9392 7.78288 14.831 7.6746C14.7228 7.56633 14.5761 7.5055 14.4231 7.5055Z" fill="white" />
                    </svg></p>
                    <svg onClick={() => {onClickHandler()}} xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <rect width="17" height="17" rx="8.5" fill="#F7F7F7" />
                        <path d="M6 4V14L13 9L6 4Z" fill="black" />
                    </svg>
                </div>
            </div>
            <div className='filter-container__fields-list'>
                {filterDashboardData && filterDashboardData.map(filterItem => (
                    <div className='filter-container__fields-list__fields' key={filterItem.FILTER_ID}>
                        <label className='filter-container__fields-list__fields__field_label' htmlFor={filterItem.FILTER_ID}>{filterItem.LABEL}</label>
                        {filterItem.DISPLAY_TYPE === 'DROPDOWN' ? (
                            <div className='filter-container__fields-list__fields__custom-dropdown'>
                                <select
                                    className='filter-container__fields-list__fields__custom-dropdown__field_option'
                                    onChange={(event) => handleFilterChange(event, filterItem.FILTER_ID)}
                                    id={filterItem.FILTER_ID}
                                    value={selectedFilterValues[filterItem?.FILTER_ID] || 'select'}
                                >
                                    <option hidden>Select</option>
                                    {filterOptions[filterItem.FILTER_ID]?.map((option, index) => (
                                        <option key={index} value={option}>{option}</option>
                                    ))}
                                </select>
                                {selectedFilterValues[filterItem?.FILTER_ID] && (
                                    <p
                                        onClick={() => {removeSelectedFilterValue(filterItem?.FILTER_ID)}}
                                        className='filter-container__fields-list__fields__custom-dropdown__delete-button'
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M10.4151 1.84385C10.4728 1.7883 10.5185 1.72233 10.5497 1.64972C10.5809 1.57711 10.597 1.49928 10.5971 1.42066C10.5971 1.34205 10.5811 1.26419 10.55 1.19155C10.5189 1.1189 10.4732 1.05288 10.4157 0.997254C10.3581 0.941631 10.2898 0.897495 10.2146 0.867366C10.1393 0.837237 10.0587 0.821705 9.97726 0.821657C9.89581 0.821609 9.81515 0.837045 9.73989 0.867085C9.66463 0.897124 9.59623 0.941179 9.5386 0.996733L5.79846 4.60688L2.05939 0.996733C1.94301 0.884398 1.78516 0.821289 1.62057 0.821289C1.45599 0.821289 1.29814 0.884398 1.18176 0.996733C1.06538 1.10907 1 1.26143 1 1.42029C1 1.57916 1.06538 1.73152 1.18176 1.84385L4.92191 5.45296L1.18176 9.06207C1.12414 9.1177 1.07843 9.18373 1.04724 9.2564C1.01605 9.32908 1 9.40697 1 9.48563C1 9.5643 1.01605 9.64219 1.04724 9.71486C1.07843 9.78754 1.12414 9.85357 1.18176 9.90919C1.29814 10.0215 1.45599 10.0846 1.62057 10.0846C1.70207 10.0846 1.78277 10.0691 1.85806 10.039C1.93335 10.0089 2.00176 9.96482 2.05939 9.90919L5.79846 6.29904L9.5386 9.90919C9.65498 10.0214 9.81277 10.0844 9.97726 10.0843C10.1417 10.0842 10.2995 10.021 10.4157 9.90867C10.5319 9.79634 10.5972 9.64404 10.5971 9.48527C10.597 9.3265 10.5315 9.17427 10.4151 9.06207L6.675 5.45296L10.4151 1.84385Z" fill="#F1F4F9" stroke="black" strokeWidth="0.2" />
                                        </svg>

                                    </p>
                                )}
                            </div>

                        ) : filterItem.DISPLAY_TYPE === 'DATE_PICKER' ? (
                            <div className='filter-container__fields-list__fields__date'>
                                <input
                                    type="date"
                                    id="from"
                                    onChange={(event) => handleFilterChange(event, "from")}
                                />
                                <input
                                    type="date"
                                    id="to"
                                    onChange={(event) => handleFilterChange(event, "to")}
                                />
                            </div>
                        ) : (
                            <input type="text" id={filterItem.FILTER_ID} />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Filter
